(
    function (skyward)
    {
        skyward.searchCondition = skyward.searchCondition || {};

        var nonAttributeProperties = ["List", "SearchCondition"];
        const ignoredPropertiesForJson = [
            "IsRestricted",
            "Parameters",
            "FieldPath",
            "LeftFieldPath",
            "RightFieldPath",
            "FieldType",
            "LeftFieldType",
            "RightFieldType",
            "FieldIsOperation",
            "LeftFieldIsOperation",
            "RightFieldIsOperation",
            "FieldPathDisplay",
            "LeftFieldPathDisplay",
            "RightFieldPathDisplay"
        ];

        var types = skyward.searchCondition.types = {
            FieldToFieldSearchCondition: "FieldToFieldSearchCondition",
            SchemaObjectFilterSearchCondition: "SchemaObjectFilterSearchCondition",
            DateTimeSearchCondition: "DateTimeSearchCondition",
            TimeSpanSearchCondition: "TimeSpanSearchCondition",
            TypedStandardFilterSearchCondition: "TypedStandardFilterSearchCondition",
            SearchConditionGroup: "SearchConditionGroup",
            AndSearchConditionGroup: "AndSearchConditionGroup",
            OrSearchConditionGroup: "OrSearchConditionGroup",
            LongSearchCondition: "LongSearchCondition",
            IntSearchCondition: "IntSearchCondition",
            ShortSearchCondition: "ShortSearchCondition",
            ByteSearchCondition: "ByteSearchCondition",
            BoolSearchCondition: "BoolSearchCondition",
            StringSearchCondition: "StringSearchCondition",
            DecimalSearchCondition: "DecimalSearchCondition",
            EnumSearchCondition: "EnumSearchCondition",
            ExistsSearchCondition: "ExistsSearchCondition"
        };

        skyward.searchCondition.getSearchConditionTypeByFieldType = function (fieldType)
        {
            switch (fieldType.toLowerCase())
            {
                case "number long":
                    return types.LongSearchCondition;
                case "number int":
                    return types.IntSearchCondition;
                case "number short":
                    return types.ShortSearchCondition;
                case "number byte":
                    return types.ByteSearchCondition;
                case "number decimal":
                    return types.DecimalSearchCondition;
                case "boolean":
                    return types.BoolSearchCondition;
                case "string":
                    return types.StringSearchCondition;
                case "time":
                case "datetime":
                    return types.DateTimeSearchCondition;
                case "timespan":
                    return types.TimeSpanSearchCondition;
                case "onetomany":
                case "manytoone":
                    return types.ExistsSearchCondition;
                case "standardfilter":
                    return types.TypedStandardFilterSearchCondition;
                default:
                    return types.EnumSearchCondition;
            }
        };

        var getFromJson = skyward.searchCondition.getFromJson = function (value)
        {
            if (!value)
            {
                return new SearchCondition();
            }

            if (typeof value === "string")
            {
                value = JSON.parse(value);
            }
            let isConditionGroup = value["@Type"] === types.SearchConditionGroup || value["@Type"] === types.AndSearchConditionGroup || value["@Type"] === types.OrSearchConditionGroup;
            let condition = (isConditionGroup) ? new SearchConditionGroup() : new SearchCondition();

            let values = {};
            for (let prop in value)
            {
                let key = (prop.indexOf("@") === 0) ? prop.substring(1) : prop;
                values[key] = value[prop];
            }
            condition.set(values);

            return condition;
        };

        var SearchCondition = skyward.searchCondition.SearchCondition = function ()
        {
            var _searchCondition = { Type: "", IsRestricted: false };
            var _existsCondition = null;

            this.setType = function (type) { _searchCondition.Type = type; };

            this.setIsRestricted = function (isRestricted) { _searchCondition.IsRestricted = isRestricted; };

            this.toJSON = function ()
            {
                return JSON.stringify(this.get());
            };

            this.removeEmptyConditions = function () { return this; };

            this.removeWhen = function (predicate)
            {
                if (predicate(this))
                {
                    return;
                }

                if (this.condition instanceof SearchCondition || this.condition instanceof SearchConditionGroup)
                {
                    this.condition = this.condition.removeWhen(predicate);
                }
                else if (_existsCondition)
                {
                    _existsCondition = _existsCondition.removeWhen(predicate);
                }

                return this;
            };

            this.get = function ()
            {
                let result = {};

                for (let prop in _searchCondition)
                {
                    if (nonAttributeProperties.indexOf(prop) >= 0)
                    {
                        result[prop] = _searchCondition[prop];
                    }
                    else if (ignoredPropertiesForJson.indexOf(prop) < 0)
                    {
                        result["@" + prop] = _searchCondition[prop];
                    }
                }

                if (_existsCondition != null)
                {
                    result.SearchCondition = _existsCondition.get();
                }
                return result;
            };

            this.getFieldsFromCondition = function (traverseExists)
            {
                if (_searchCondition.IsRestricted || _searchCondition.Type === types.TypedStandardFilterSearchCondition)
                {
                    return [];
                }

                let fields = [];

                const leftField = $.nullCoalesce(_searchCondition.FieldName, _searchCondition.LeftFieldName);
                if (leftField)
                {
                    const leftDisplayField = $.nullCoalesce(_searchCondition.FieldNameDisplay, _searchCondition.LeftFieldNameDisplay, _searchCondition.FieldName, _searchCondition.LeftFieldName);
                    const leftDisplayPath = $.nullCoalesce(_searchCondition.FieldPathDisplay, _searchCondition.LeftFieldPathDisplay);
                    const leftFieldPath = $.nullCoalesce(_searchCondition.FieldPath, _searchCondition.LeftFieldPath);
                    const leftFieldType = $.nullCoalesce(_searchCondition.FieldType, _searchCondition.LeftFieldType);
                    const leftFieldIsOperation = $.nullCoalesce(_searchCondition.FieldIsOperation, _searchCondition.LeftFieldIsOperation);
                    fields.push(buildFieldData(leftField,
                        leftFieldPath,
                        leftDisplayField,
                        leftDisplayPath,
                        _searchCondition.DataObjectType,
                        leftFieldType,
                        _searchCondition.CalculatedFieldName,
                        leftFieldIsOperation,
                        _searchCondition.Parameters));
                }

                const rightField = _searchCondition.RightFieldName;
                if (rightField)
                {
                    const rightDisplayField = $.nullCoalesce(_searchCondition.RightFieldNameDisplay, _searchCondition.RightFieldName);
                    const rightDisplayPath = _searchCondition.RightFieldPathDisplay;
                    const rightFieldPath = _searchCondition.RightFieldPath
                    const rightFieldType = _searchCondition.RightFieldType;
                    const rightFieldIsOperation = _searchCondition.RightFieldIsOperation;
                    fields.push(buildFieldData(rightField,
                        rightFieldPath,
                        rightDisplayField,
                        rightDisplayPath,
                        _searchCondition.DataObjectType,
                        rightFieldType,
                        _searchCondition.RightCalculatedFieldName,
                        rightFieldIsOperation,
                        _searchCondition.Parameters));
                }

                const condition = _searchCondition.ConditionType;
                if (traverseExists && (condition === "Exists" || condition === "NotExists") && _existsCondition)
                {
                    fields.push(..._existsCondition.getFieldsFromCondition(traverseExists));
                }

                function buildFieldData(fieldName, fieldPath, displayName, displayPath, dataObjectType, fieldType, calculatedFieldName, isOperation, parameters)
                {
                    const searchConditionFieldData =
                    {
                        fieldName: fieldName,
                        fieldPath: fieldPath,
                        dataObjectType: dataObjectType,
                        displayName: displayName,
                        displayPath: displayPath,
                        fieldType: fieldType,
                        calculatedFieldName: calculatedFieldName,
                        isOperation: isOperation,
                        parameters: parameters
                    };

                    return searchConditionFieldData;
                }

                return fields;
            };

            this.toFriendlyQuery = function ()
            {
                if (_searchCondition.IsRestricted)
                {
                    return "( *** )";
                }

                const condition = _searchCondition.ConditionType;
                const leftCalculatedFieldBinding = formatCalculatedFieldIDForBinding(_searchCondition.CalculatedFieldName);
                const rightCalculatedFieldBinding = formatCalculatedFieldIDForBinding(_searchCondition.RightCalculatedFieldName);

                let leftDisplayValue;
                if (_searchCondition.Version > 1)
                {
                    leftDisplayValue = $.nullCoalesce(_searchCondition.FieldNameDisplay, leftCalculatedFieldBinding, _searchCondition.LeftFieldNameDisplay, _searchCondition.RelationshipNameDisplay);
                }
                else
                {
                    leftDisplayValue = $.nullCoalesce(_searchCondition.FieldName, leftCalculatedFieldBinding, _searchCondition.LeftFieldName, _searchCondition.RelationshipName);
                }
                const lowDisplayValue = $.nullCoalesce(_searchCondition.LowBinding, _searchCondition.ValueBinding, _searchCondition.Low, _searchCondition.Value,
                    _searchCondition.RightFieldNameDisplay, _searchCondition.RightFieldName, _searchCondition.ListBinding, rightCalculatedFieldBinding,
                    (_searchCondition.List && _searchCondition.List.Value) ? _searchCondition.List.Value.join(";") : _searchCondition.List);
                const highDisplayValue = $.nullCoalesce(_searchCondition.HighBinding, _searchCondition.High);

                let friendlyQuery = null;

                if (_searchCondition.Type === types.TypedStandardFilterSearchCondition)
                {
                    return "( " + _searchCondition.DisplayName + " )";
                }

                switch (condition)
                {
                    case "Exists":
                        friendlyQuery = "At Least One '" + leftDisplayValue + "' Exist";
                        if (_existsCondition)
                        {
                            friendlyQuery += " Where (" + _existsCondition.toFriendlyQuery() + ")";
                        }
                        break;
                    case "NotExists":
                        friendlyQuery = "No '" + leftDisplayValue + "' Exist";
                        if (_existsCondition)
                        {
                            friendlyQuery += " Where (" + _existsCondition.toFriendlyQuery() + ")";
                        }
                        break;
                    case "True":
                    case "False":
                    case "Null":
                    case "NotNull":
                        friendlyQuery = "'" + leftDisplayValue + "' is " + condition.toDisplayName();
                        break;
                    case "BetweenInclusive":
                    case "BetweenExclusive":
                    case "NotBetweenInclusive":
                    case "NotBetweenExclusive":
                        friendlyQuery = "'" + leftDisplayValue + "' " + condition.toDisplayName() + " ( '" + lowDisplayValue + "' And '" + highDisplayValue + "' )";
                        break;
                    default:
                        if (condition)
                        {
                            friendlyQuery = "'" + leftDisplayValue + "' " + condition.toDisplayName() + " '" + lowDisplayValue + "'";
                        }
                        else if (_searchCondition.Type === types.SchemaObjectFilterSearchCondition)
                        {
                            friendlyQuery = "'" + leftDisplayValue + "' is True";
                        }
                        else if (_searchCondition.Type === types.TypedStandardFilterSearchCondition)
                        {
                            friendlyQuery = leftDisplayValue;
                        }
                        break;
                }

                if (friendlyQuery)
                {
                    friendlyQuery = "( " + friendlyQuery + " )";
                    friendlyQuery = convertBindingsToFriendlyNames(friendlyQuery);
                }

                return friendlyQuery;
            };

            this.getValidationMessage = function ()
            {
                const allowedNoValueConditionTypes = ["True", "False", "Null", "NotNull", "List", "NotList"];
                const leftCalculatedFieldBinding = formatCalculatedFieldIDForBinding(_searchCondition.CalculatedFieldName);

                let fieldName;
                if (_searchCondition.Type == types.FieldToFieldSearchCondition)
                {
                    fieldName = $.nullCoalesce(_searchCondition.LeftFieldName, leftCalculatedFieldBinding);
                }
                else if (_searchCondition.Version > 1)
                {
                    fieldName = $.nullCoalesce(_searchCondition.FieldNameDisplay, leftCalculatedFieldBinding);
                }
                else
                {
                    fieldName = $.nullCoalesce(_searchCondition.FieldName, leftCalculatedFieldBinding);
                }

                fieldName = convertBindingsToFriendlyNames(fieldName);

                switch (_searchCondition.Type)
                {
                    case types.TypedStandardFilterSearchCondition:
                    case types.SchemaObjectFilterSearchCondition:
                        return null;
                    default:
                        if (!_searchCondition.ConditionType)
                        {
                            if (fieldName)
                            {
                                return "Condition Type must be set for " + fieldName + ".";
                            }

                            return "Condition Type must be set.";
                        }
                        if (_searchCondition.Type != types.StringSearchCondition && _searchCondition.Type != types.ExistsSearchCondition && !allowedNoValueConditionTypes.includes(_searchCondition.ConditionType))
                        {
                            let hasValue = Boolean(_searchCondition.Value || _searchCondition.Value === false || _searchCondition.ValueBinding);
                            let hasLow = Boolean(_searchCondition.Low || _searchCondition.LowBinding);
                            let hasHigh = Boolean(_searchCondition.High || _searchCondition.HighBinding);
                            let hasRightField = Boolean(_searchCondition.RightFieldName || _searchCondition.RightCalculatedFieldName);
                            if (!(hasValue || hasRightField || (hasLow && hasHigh)))
                            {
                                if (fieldName)
                                {
                                    return "Condition must have a value for " + fieldName + ".";
                                }
                                return "Condition must have a value."
                            }

                            let maxValue = this.getMaxNumericValue();
                            if (maxValue)
                            {
                                let message = " is an invalid value. Condition value must be between -" + maxValue + " and " + maxValue + ".";
                                if (_searchCondition.Value && Math.abs(_searchCondition.Value) > maxValue)
                                {
                                    return _searchCondition.Value + message;
                                }
                                if (_searchCondition.Low && Math.abs(_searchCondition.Low) > maxValue)
                                {
                                    return _searchCondition.Low + message;
                                }
                                if (_searchCondition.High && Math.abs(_searchCondition.High) > maxValue)
                                {
                                    return _searchCondition.High + message;
                                }
                            }
                        }
                        return null;
                }
            };

            this.getMaxNumericValue = function ()
            {
                switch (_searchCondition.Type)
                {
                    /* Unable to use a value of 9223372036854775807 when the type is LongSearchCondition, since we don't support using BigInt yet due to old versions of Safari on older iOS devices.
                     * To get around this limitation we are masking the search condition value to at most 18 characters instead of 19, which guaranties the input is a valid long and we can skip this validation.
                     * See PR 5271305
                     */
                    case types.IntSearchCondition:
                        return 2147483647;
                    case types.ShortSearchCondition:
                        return 32767;
                    case types.ByteSearchCondition:
                        return 255;
                }
                return null;
            };

            this.set = function (keyValues)
            {
                for (var key in keyValues)
                {
                    if (key == "SearchCondition" || key === "Condition")
                    {
                        _existsCondition = getFromJson(keyValues[key]);
                    }
                    else if (key == "List")
                    {
                        if (keyValues[key].Value && !Array.isArray(keyValues[key].Value))
                        {
                            _searchCondition["List"] = { Value: [keyValues["List"].Value] };
                        }
                        else
                        {
                            _searchCondition["List"] = keyValues["List"];
                        }
                    }
                    else if (keyValues[key] != null)
                    {
                        _searchCondition[key] = keyValues[key];
                    }
                    else if (_searchCondition[key] !== undefined)
                    {
                        delete _searchCondition[key];
                    }
                }
            };

            function formatCalculatedFieldIDForBinding(calculatedFieldID)
            {
                return calculatedFieldID ? `{${calculatedFieldID}}` : null;
            }

            function convertBindingsToFriendlyNames(text)
            {
                if (text)
                {
                    if (skyward.reporting.prompts && skyward.reporting.prompts.promptCollection
                        && typeof skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames === 'function')
                    {
                        text = skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(text);
                    }

                    if (skyward.reporting.calculatedFields && typeof skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames === 'function')
                    {
                        text = skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames(text);
                    }
                }

                return text;
            }
        };

        var SearchConditionGroup = skyward.searchCondition.SearchConditionGroup = function ()
        {
            var _searchConditionGroup = { Type: types.SearchConditionGroup };
            var _conditions = [];

            this.removeEmptyConditions = function ()
            {
                if (_conditions.length === 0)
                {
                    return null;
                }

                if (_conditions.length === 1)
                {
                    return _conditions[0].removeEmptyConditions();
                }

                return this;
            };

            this.removeWhen = function (predicate)
            {
                if (predicate(this))
                {
                    return;
                }
                for (var key in _conditions)
                {
                    var result = _conditions[key].removeWhen(predicate);
                    if (result != undefined)
                    {
                        _conditions[key] = result;
                    }
                    else
                    {
                        delete _conditions[key];
                    }
                };

                return this;
            };

            this.getFieldsFromCondition = function (traverseExists)
            {
                if (_conditions.length === 0)
                {
                    return [];
                }

                if (_conditions.length === 1)
                {
                    return _conditions[0].getFieldsFromCondition(traverseExists);
                }

                let conditionFields = [];

                _conditions.forEach(function (condition)
                {
                    let fields = condition.getFieldsFromCondition(traverseExists);
                    if (fields?.length > 0)
                    {
                        conditionFields.push(...fields);
                    }
                });

                return conditionFields;
            };

            this.toFriendlyQuery = function ()
            {
                if (_conditions.length === 0)
                {
                    return "";
                }

                if (_conditions.length === 1)
                {
                    return _conditions[0].toFriendlyQuery();
                }

                var conditionQueries = [];

                _conditions.forEach(function (condition)
                {
                    var friendlyQuery = condition.toFriendlyQuery();
                    if (friendlyQuery)
                    {
                        conditionQueries.push(friendlyQuery);
                    }
                });

                var joinWith = " " + _searchConditionGroup.ConditionGroupType + " ";

                return "( " + conditionQueries.join(joinWith) + " )";
            };

            this.toJSON = function ()
            {
                if (_conditions.length === 0)
                {
                    return "";
                }

                if (_conditions.length === 1)
                {
                    return _conditions[0].toJSON();
                }

                return JSON.stringify(this.get());
            };

            this.getValidationMessage = function ()
            {
                var messages = [];
                _conditions.forEach(function (condition)
                {
                    var conditionMessage = condition.getValidationMessage();
                    if (conditionMessage)
                    {
                        messages.push(conditionMessage);
                    }
                });
                return messages.join("\r\n");
            };

            this.get = function ()
            {
                var result = {};
                for (var prop in _searchConditionGroup)
                {
                    if (nonAttributeProperties.indexOf(prop) >= 0)
                    {
                        result[prop] = _searchConditionGroup[prop];
                    }
                    else
                    {
                        result["@" + prop] = _searchConditionGroup[prop];
                    }
                }

                result.SearchCondition = [];
                _conditions.forEach(function (condition)
                {
                    result.SearchCondition.push(condition.get());
                });

                return result;
            };

            this.set = function (keyValues)
            {
                for (var key in keyValues)
                {
                    if (key === "SearchCondition")
                    {
                        var nestedCondition;
                        if (Array.isArray(keyValues[key]))
                        {
                            for (var i = 0; i < keyValues[key].length; i++)
                            {
                                nestedCondition = getFromJson(keyValues[key][i]);
                                this.addCondition(nestedCondition);
                            }
                        }
                        else
                        {
                            nestedCondition = getFromJson(keyValues[key]);
                            this.addCondition(nestedCondition);
                        }
                    }
                    else if (keyValues[key] != null)
                    {
                        _searchConditionGroup[key] = keyValues[key];
                    }
                    else if (_searchConditionGroup[key] !== undefined)
                    {
                        delete _searchConditionGroup[key];
                    }
                }
            };

            this.addCondition = function (searchCondition)
            {
                var condition = searchCondition.removeEmptyConditions();
                if (condition)
                {
                    _conditions.push(condition);
                }
            };
        };
    }(window.skyward = window.skyward || {})
);